module.exports = {
    packagingFeeSwitches: {
        enablePreferencePreselection: true,
        packagingNotificationEnabled: true,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/packaging-fee-switches.js